import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import customColorMixin from '@/mixins/customColor';
import stateHistoryFetchMixin from '@/mixins/stateHistoryFetch';
import { get, debounce } from 'lodash';
export default {
  name: 'CoreVirtualDevicePacketHistoryViewer',
  mixins: [customColorMixin, stateHistoryFetchMixin],
  props: {
    height: {
      type: Number,
      default: 300,
      required: false
    },
    queryStartDate: {
      type: String,
      required: false,
      default: null
    },
    queryEndDate: {
      type: String,
      required: false,
      default: null
    },
    isAutoRefresh: {
      type: Boolean,
      required: true
    },
    isReset: {
      type: Boolean,
      required: false
    },
    rawStateId: {
      type: Number,
      required: true
    },
    virtualDeviceId: {
      type: Number,
      required: true
    },
    bridgeManifest: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      packetHistory: [],
      dataIsLoading: false,
      loadingDone: false,
      loadingError: null,
      offset: 0,
      serverItemsLength: -1,
      update: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), {}, {
    hasNoPackets: function hasNoPackets() {
      return !this.dataIsLoading && this.packetHistory.length === 0 && this.loadingDone;
    },
    colNumber: function colNumber() {
      return 5 + (get(this.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.port') ? 1 : 0) + (this.bridgeManifest.virtualDevice.metaData || []).length;
    },
    isLiveViewer: function isLiveViewer() {
      // NOTE: isLiveViewer is a prop handed over to `packet-parser`, whilst referencing the same component
      // so to bypass this kinda "race-condition", include `loadingDone` which is set with a delay,
      // to force to re-eval this computed prop, when the `packet-viewer`-ref evaluated correctly
      if (this.$refs['packet-viewer']) {
        return false;
      }

      return this.isAutoRefresh && this.loadingDone && !this.$refs['packet-viewer'].scrolledDown;
    }
  }),
  watch: {
    queryItemsInflux: debounce(function () {
      if (this.isAutoRefresh) {
        // only auto-refresh if the user is scrolled all the way up to the top
        // otherwise do not destroy the current state/entry the user might be looking at!
        var el = this.$refs['packet-viewer'].$refs['top-element'];

        if (!el) {
          return;
        }

        var holder = this.$refs['packet-viewer'].$refs['outer-container'];

        var _el$getBoundingClient = el.getBoundingClientRect(),
            top = _el$getBoundingClient.top,
            bottom = _el$getBoundingClient.bottom,
            height = _el$getBoundingClient.height;

        var holderRect = holder.getBoundingClientRect();
        var isVisible = top <= holderRect.top ? holderRect.top - top <= height : bottom - holderRect.bottom <= height;

        if (!isVisible && !this.isReset) {
          // do not auto-refresh if the title is not visible, i.e. the content is scrolled
          return;
        }
      }

      this.isReset = false;
      this.offset = 0;
      this.loadData(false, true);
    }, 500, {
      leading: true
    })
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    clickRowHandler: function clickRowHandler(item) {
      this.$emit('click', item);
    },
    get: get,
    loadData: function loadData(increaseOffset) {
      var _this = this;

      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.dataIsLoading) {
        return;
      }

      this.loadingError = null;
      this.dataIsLoading = true;

      if (increaseOffset) {
        this.offset += 1;
      }

      var usedPage = this.offset;
      var usedItemsPerPage = 50;
      var sortDirection = 'DESC';
      this.loadDetailledHistoryData(this.rawStateId, this.virtualDeviceId, 'time', sortDirection, usedPage, usedItemsPerPage).then(function (res) {
        var _this$packetHistory;

        _this.serverItemsLength = res.totalCount;

        if (reset) {
          _this.packetHistory = [];
        }

        (_this$packetHistory = _this.packetHistory).push.apply(_this$packetHistory, _toConsumableArray(res.items));

        if (_this.packetHistory.length > 0) {
          _this.$emit('click', _this.packetHistory[0]);
        }

        return _this.packetHistory;
      }).catch(function (err) {
        if (err.code === 'ECONNABORTED') {
          _this.loadingError = 'TIMEOUT';
        } else {
          _this.loadingError = 'UKNOWN';
        }
      }).finally(function () {
        _this.dataIsLoading = false;
        _this.loadingDone = true;
      });
    }
  }
};